"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const text_area_props_js_1 = require("./text-area.props.js");
const index_js_1 = require("../helpers/index.js");
const TextArea = React.forwardRef((props, forwardedRef) => {
    const { className, color, radius, style, ...textAreaProps } = (0, index_js_1.extractProps)(props, text_area_props_js_1.textAreaPropDefs, index_js_1.marginPropDefs);
    return (React.createElement("div", { "data-accent-color": color, "data-radius": radius, className: (0, classnames_1.default)('rt-TextAreaRoot', className), style: style },
        React.createElement("textarea", { className: "rt-reset rt-TextAreaInput", ref: forwardedRef, ...textAreaProps }),
        React.createElement("div", { className: "rt-TextAreaChrome" })));
});
exports.TextArea = TextArea;
TextArea.displayName = 'TextArea';
//# sourceMappingURL=text-area.js.map